import {Box, Container} from "@mui/material"; // Оставил только то, что используется в примере
import { useSelector } from "react-redux";
import {useParams} from "react-router-dom";

export const MephistoProfile = () => {
    const CommonData = useSelector((state) => state.data.CommonData);

    const {game, action, deviceId} = useParams();

    const iframeUrl = `https://${game}-mephisto.belka-games.com/profile_iframe?env=production&userId=${deviceId}`;

    return (
        <Box
            style={{ height: '65vh', background:'#fff' }}
            sx={{
                maxWidth: "100%",
                pl: 0,
                mt: 1
            }}>
            {deviceId && (
                <iframe
                    key={deviceId}
                    src={iframeUrl}
                    title="Device Profile"
                    width="100%"
                    height="100%"
                    style={{ border: "none" }}
                />
            )}
            {!deviceId && <div>Select Device ID...</div>}
        </Box>
    );
};